import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Allergens.module.css';

function Allergens() {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const allergenItems = Array.from({ length: 14 }, (_, i) => i + 1);

  return (
    <div className={styles.allergensContainer}>
      <div className={styles.allergensCard}>
        <h3 className={styles.title}>{t('allergens-title')}</h3>
        <p className={styles.subtitle}>{t('allergens-subtitle')}</p>
        
        <button onClick={toggleOpen} className={styles.toggleButton}>
          {isOpen ? t('allergens-button-hide') : t('allergens-button-show')}
          <span className={`${styles.arrow} ${isOpen ? styles.arrowUp : styles.arrowDown}`}>▼</span>
        </button>

        {isOpen && (
          <div className={styles.allergensContent}>
            <p className={styles.intro}>{t('allergens-intro')}</p>
            <ul className={styles.allergensList}>
              {allergenItems.map(num => (
                <li key={num} className={styles.allergenItem}>
                  {t(`allergens-item-${num}`)}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

export default Allergens;
